import { createElement } from 'react';

import type { IconProps } from '../icon/icon';
import { Icon } from '../icon/icon'; // props is just passed in to keep variables.jsx happy. We don’t use variables.props
const SvgPersonIcon = (componentProps: IconProps, props = {}) => {
  return createElement(
    Icon,
    componentProps,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      {...props}
    >
      <path
        fill="#353C4A"
        fillRule="evenodd"
        d="M5.527 26.498c2.555 0 7.032-.002 10.498 0 3.477.003 7.939.002 10.475.001v-3.143a3 3 0 0 0-.248-.384 10 10 0 0 0-1.072-1.187c-.926-.895-2.13-1.845-3.294-2.612-1.38-.911-3.506-1.673-5.85-1.673s-4.47.762-5.85 1.673c-1.184.78-2.41 1.75-3.34 2.658-.468.455-.825.861-1.062 1.19a3 3 0 0 0-.216.343zm-1.955-3.429-.059 4.416a1 1 0 0 0 .998 1.013c2.196 0 7.524-.002 11.513 0 4 .003 9.302.002 11.479.001a1 1 0 0 0 .997-1v-4.357a.7.7 0 0 0-.012-.144c-.284-1.393-2.995-3.842-5.5-5.495-1.697-1.119-4.203-2.003-6.952-2.003s-5.255.884-6.951 2.003c-2.55 1.681-5.31 4.187-5.513 5.566M20.073 8.587A4.1 4.1 0 0 0 15.987 4.5 4.1 4.1 0 0 0 11.9 8.587a4.1 4.1 0 0 0 4.087 4.086 4.1 4.1 0 0 0 4.086-4.086M15.987 2.5c3.35 0 6.086 2.737 6.086 6.087s-2.737 6.086-6.086 6.086S9.9 11.936 9.9 8.587 12.637 2.5 15.987 2.5"
        clipRule="evenodd"
      />
    </svg>,
  );
};
export default SvgPersonIcon;
